import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Title from "../common/Title";
import Grid from "../common/Grid";
import { GiMegaphone } from "react-icons/gi";
import Utils from "../../utils";
import { broadcastMessageActions } from "../../actions/broadcastMessage.actions";
import BroadcastMessageGridFilter from "./BroadcastMessageGridFilter";
import { MdDelete, MdEdit } from "react-icons/md";
import ConfirmModal from "../common/ConfirmModal";
import { Alert, Button } from "react-bootstrap";
import { FaEye } from "react-icons/fa";
import GridHelper from "../helpers/gridHelper";

function BroadcastMessageGrid(props) {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const broadcastMessage = useSelector((state) => state.broadcastMessage);
  const [confirmDeleteModalShow, setConfirmDeleteModalShow] = useState(false);
  const [deleteMessageId, setDeleteMessageId] = useState("");

  const filterInitialState = {
    variant: "",
    displayedOn: "",
  };
  const [filter, setFilter] = useState(filterInitialState);

  const actions = [
    {
      text: "Reviews",
      event: (id) =>
        props.onViewReviews ? props.onViewReviews(id) : navigate(`reviews?messageId=${id}`),
      icon: <FaEye className="mb-1 me-2" />,
    },
    {
      text: "Edit",
      event: (id) =>
        props.onEditMessage ? props.onEditMessage(id) : navigate(`edit?messageId=${id}`),
      icon: <MdEdit className="mb-1 me-2" />,
    },
    {
      text: "Delete",
      event: (id) => {
        setDeleteMessageId(id);
        setConfirmDeleteModalShow(true);
      },
      icon: <MdDelete className="mb-1 me-2" />,
    },
  ];

  useEffect(() => {
    let queryParams = Utils.getQueryStringParams(location);
    queryParams["clientId"] = props.user.clientId;
    queryParams["clientGuid"] = props.user.clientGuid;

    dispatch(broadcastMessageActions.get(queryParams));

    // Initialize filter from URL
    setFilter({
      variant: queryParams["variant"],
      displayedOn: queryParams["displayedOn"],
    });

    // eslint-disable-next-line
  }, [location]);

  const handleClearFilters = () => {
    GridHelper.handleSearch(filterInitialState, location, navigate);
  };

  const handleDeleteBroadcastMessage = () => {
    setConfirmDeleteModalShow(false);
    let requestParameters = {
      messageId: deleteMessageId,
      clientid: props.user.clientId,
      clientGuid: props.user.clientGuid,
    };

    dispatch(broadcastMessageActions.remove(requestParameters));
  };

  let displayColumns = [
    "title",
    "content",
    "variant",
    "displayStartDate",
    "displayEndDate",
    "createdByUserName",
  ];
  if (props.user.isSuperUser) displayColumns.push("clientName");

  const data = broadcastMessage.paginatedResult?.data.map((m) => {
    return {
      ...m,
      displayStartDate: Utils.convertToDateOnly(m.displayStartDate),
      displayEndDate: Utils.convertToDateOnly(m.displayEndDate),
      variant: (
        <Alert variant={m.variant} className="py-0 px-1 m-0">
          {Utils.fixCamelCase(m.variant)}
        </Alert>
      ),
    };
  });

  return (
    <>
      {!props.hideTitle && (
        <Title
          text="Broadcast Messages"
          icon={<GiMegaphone className="mb-1" />}
        />
      )}

      <BroadcastMessageGridFilter
        filter={filter}
        onClearFilters={handleClearFilters}
      />

      <Button
        variant="primary"
        className="float-end mb-2"
        onClick={() => (props.onAddMessage ? props.onAddMessage() : navigate("add"))}
      >
        Add Broadcast Message
      </Button>

      <Grid
        data={data}
        fillHeight={props.hideTitle}
        displayColumns={displayColumns}
        idColumn={"messageId"}
        actions={actions}
        pageNumber={(broadcastMessage.paginatedResult?.pageNumber ?? 1) - 1}
        totalPages={broadcastMessage.paginatedResult?.totalPages ?? 0}
        loading={broadcastMessage.loading}
        onPageChange={GridHelper.handlePageClick}
        onSort={GridHelper.handleSortClick}
      ></Grid>

      <ConfirmModal
        show={confirmDeleteModalShow}
        title="Delete Broadcast Message"
        question={`Are you sure you want to delete broadcast message?`}
        noButtonText="No"
        yesButtonText="Yes, please"
        handleClose={() => {
          setConfirmDeleteModalShow(false);
        }}
        handleConfirm={() => {
          handleDeleteBroadcastMessage();
        }}
      />
    </>
  );
}

export default BroadcastMessageGrid;
